import type { RouteAccess } from 'src/routes/routeAccess';

/**
 * Registry mapping internal and marketplace app IDs to their required routeAccess checks.
 * Apps listed here will be hidden from the sidebar if the corresponding
 * routeAccess check returns false.
 */
export const APP_REQUIRED_ROUTE_ACCESS: Record<string, keyof RouteAccess> = {
  // Billing integrations use allowPaymentsPage routeAccess check
  'c14f8c76-0004-4624-9754-cef11e263fe9': 'allowPaymentsPage', // Xero
  '9a90624e-5998-48ae-a7c4-917f473fedcc': 'allowPaymentsPage', // QuickBooks
  payments: 'allowPaymentsPage', // Payments
};

export const hasAppRouteAccess = (appId: string, routeAccess: RouteAccess) => {
  const routeAccessKey = APP_REQUIRED_ROUTE_ACCESS[appId];
  if (routeAccessKey) {
    const hasAccess = routeAccess[routeAccessKey];
    if (hasAccess === false) {
      return false;
    }
  }
  return true;
};
